import api from '@/common/api.js'
import { getTutorialMock } from '@/utils/tutorialMock.js'

/* eslint-disable */
// Modal de "Tutorial dessa tela", acionado pela TabsBar. O conteúdo vem
// de /portal-bi/getTutorial (JSON com titulo + passos); enquanto esse
// endpoint não existir no backend, cai para um mock local.

export default {
    namespaced: true,

    state: {
        aberto: false,
        carregando: false,
        dados: null,
        erro: false
    },

    getters: {
        aberto: (state) => state.aberto,
        carregando: (state) => state.carregando,
        dados: (state) => state.dados,
        erro: (state) => state.erro
    },

    mutations: {
        SET_ABERTO(state, valor) {
            state.aberto = valor
        },
        SET_CARREGANDO(state, valor) {
            state.carregando = valor
        },
        SET_DADOS(state, dados) {
            state.dados = dados
        },
        SET_ERRO(state, valor) {
            state.erro = valor
        }
    },

    actions: {
        async abrir({ commit, dispatch }, { lkLink, dsLink }) {
            commit('SET_ABERTO', true)
            await dispatch('buscarTutorial', { lkLink, dsLink })
        },
        fechar({ commit }) {
            commit('SET_ABERTO', false)
        },
        async buscarTutorial({ commit }, { lkLink, dsLink }) {
            commit('SET_CARREGANDO', true)
            commit('SET_ERRO', false)

            try {
                const response = await api.get('/portal-bi/getTutorial', {
                    params: { link: lkLink }
                })

                commit('SET_DADOS', response.data)
            } catch (error) {
                // Endpoint ainda não existe no backend - usa mock pra não travar a tela.
                commit('SET_DADOS', getTutorialMock(lkLink, dsLink))
            } finally {
                commit('SET_CARREGANDO', false)
            }
        }
    }
}
